import { ClipboardCheck, Headphones, MapPinned, PackageCheck, Route, Truck } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const strengths = [
  { icon: Route, title: "Jaringan Mitra", desc: "Mendukung kebutuhan pelanggan dari Mojokerto ke berbagai wilayah Indonesia." },
  { icon: Headphones, title: "Tim Sales Responsif", desc: "Konsultasi produk, ketersediaan, dan penawaran dapat dibantu langsung oleh tim kami." },
  { icon: ClipboardCheck, title: "Kebutuhan Proyek", desc: "Kami terbiasa menyesuaikan rekomendasi produk dengan aplikasi dan skala kebutuhan." },
  { icon: PackageCheck, title: "Pasokan Bertahap", desc: "Lini produk dapat terus dikembangkan mengikuti permintaan pasar dan kebutuhan pelanggan." },
  { icon: Truck, title: "Pengiriman Nasional", desc: "Dukungan pengiriman untuk pelanggan retail, kontraktor, dan kebutuhan proyek." },
  { icon: MapPinned, title: "Berbasis di Jawa Timur", desc: "Lokasi operasional di Mojokerto membantu kami menjangkau pasar regional dan nasional." },
];

export const CorporateStrengths = ({ compact = false }) => (
  <section
    id="keunggulan"
    data-testid="corporate-strengths-section"
    className={`strength-story${compact ? " strength-story--compact" : ""}`}
  >
    <div className="strength-story__visual-wrap">
      <div className="strength-story__visual">
        <img src={PHOTOS.animaxProductionMachine} alt="Produksi PT Animax Putra Lancar" />
        <div className="strength-story__visual-copy">
          <span>PT. Animax Putra Lancar</span>
          <strong>2021</strong>
          <small>Berdiri Sejak</small>
        </div>
      </div>
    </div>

    <div className="strength-story__content">
      <div className="tag-uppercase text-[#e60012] mb-4">Kenapa Memilih Kami</div>
      <h2>Partner yang siap mendukung kebutuhan material Anda</h2>
      <p className="strength-story__lead">
        Fokus kami bukan hanya menjual produk, tetapi membantu pelanggan menemukan material
        yang sesuai dengan kebutuhan aplikasi, lokasi, dan timeline proyek.
      </p>

      <div className="strength-story__list">
        {strengths.map((item, index) => (
          <article key={item.title} data-testid={`corporate-strength-${index}`}>
            <span className="strength-story__index">0{index + 1}</span>
            <item.icon />
            <div><h3>{item.title}</h3><p>{item.desc}</p></div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
